import type { ReactNode } from 'react';

import { OcTheme } from '@openclassrooms/ui-web/theme';
import { DataConnectProvider } from '@openclassrooms/data-connect-web/utils';
import { I18nProvider } from '@openclassrooms/translations/I18nProvider';
import { getActiveLang, getActiveCountry } from '@openclassrooms/translations';
import { getAllTranslations } from '@openclassrooms/translations/i18nService';
import { LocalisationConfigProvider } from '@openclassrooms/localisation/LocalisationConfigProvider';
import { getAllLocalisationConfig } from '@openclassrooms/localisation/services';
import { ConfigProvider } from '@openclassrooms/utils/ConfigProvider';
import { getPreferences } from '@openclassrooms/utils/config';
import { SnackbarProvider } from 'Modules/snackbars/SnackbarProvider';

interface Props {
  productionPrefix?: string;
  children: ReactNode;
}

const AppProviders = ({ productionPrefix, children }: Props) => {
  const lang = getActiveLang();
  const country = getActiveCountry();

  const i18n = {
    lang,
    country,
    locale: `${lang}-${country}`,
    messages: getAllTranslations()[lang],
  };

  return (
    <OcTheme productionPrefix={productionPrefix}>
      <ConfigProvider config={getPreferences()}>
        <LocalisationConfigProvider config={getAllLocalisationConfig()}>
          <I18nProvider {...i18n}>
            <DataConnectProvider>
              <SnackbarProvider>{children}</SnackbarProvider>
            </DataConnectProvider>
          </I18nProvider>
        </LocalisationConfigProvider>
      </ConfigProvider>
    </OcTheme>
  );
};

export default AppProviders;
